import { useCoreServices } from '@bangle.io/context';
import { sarizIconUrl } from '@bangle.io/ui-components';
import { useAtomValue } from 'jotai';
import React from 'react';
import { getRelativeTimeOrNull } from '../common/get-relative-time';
import { Actions } from '../components/common/actions';
import { ContentSection } from '../components/common/content-section';
import { PageHeader } from '../components/common/page-header';
import { ItemList } from '../components/lists/item-list';
import { AppHeader } from '../layout/app-header';
import { PageContentContainer } from '../layout/main-content-container';

const MAX_RECENT_WORKSPACES = 5;

export function PageWelcome() {
  const { commandDispatcher, workspaceState, userActivityService, navigation } =
    useCoreServices();
  const workspaces = useAtomValue(workspaceState.$workspaces);
  const isNewUser = useAtomValue(userActivityService.$isNewUser);

  const workspaceLinks = React.useMemo(
    () =>
      workspaces.slice(0, MAX_RECENT_WORKSPACES).map((ws) => ({
        label: ws.name,
        href: navigation.toUri({
          route: 'ws-home',
          payload: { wsName: ws.name },
        }),
        rightElement: ws.lastModified ? (
          <span className="text-muted-foreground text-xs">
            {getRelativeTimeOrNull(ws.lastModified)}
          </span>
        ) : null,
      })),
    [workspaces, navigation],
  );

  const welcomeMessage = isNewUser
    ? t.app.pageWelcome.newUser
    : t.app.pageWelcome.regularUser;

  return (
    <>
      <AppHeader />
      <PageContentContainer>
        <ContentSection hasPadding>
          <PageHeader
            title={welcomeMessage}
            illustration={
              <img
                src={sarizIconUrl}
                alt={t.app.common.appLogoAlt}
                className="h-52 w-52 object-contain sm:h-64 sm:w-64"
              />
            }
          />
          <ItemList // Use ItemList instead of PageItemList
            heading={t.app.pageWelcome.recentWorkspacesHeading}
            items={workspaceLinks}
            emptyMessage={t.app.pageWelcome.createWorkspacePrompt}
            showViewMore={workspaces.length > MAX_RECENT_WORKSPACES}
            onClickViewMore={() =>
              commandDispatcher.dispatch(
                'command::ui:switch-workspace',
                null,
                'ui',
              )
            }
          />
          <Actions
            actions={[
              {
                label: t.app.pageWorkspaceNotFound.createWorkspaceButton,
                onClick: () =>
                  commandDispatcher.dispatch(
                    'command::ui:create-workspace-dialog',
                    null,
                    'ui',
                  ),
              },
            ]}
          />
        </ContentSection>
      </PageContentContainer>
    </>
  );
}
